import settings from '../settings.js'

const $inject = ['$scope', 'common', 'ArticleService', 'UserService', '$ionicConfig', '$state', '$sce', '$ionicHistory']

function TodayCtrl(scope, common, ArticleService, UserService, ionicConfig, state, sce, ionicHistory) {
    scope.setLanguage = UserService.setLanguage;
    scope.getLangCode = UserService.getLangCode;

    scope.settings = settings;

    const slidesSettings = {
        category: settings.todayCategories.slider,
        page: 1,
        perPage: 3
    };

    const newsSettings = {
        category: settings.todayCategories.normal,
        page: 1,
        perPage: 10
    };

    scope.slides = [];
    scope.news = [];
    scope.moreDataCanBeLoaded = false;
    scope.loading = true;

    scope.lastLangCode = null;

    scope.verifyLanguage = () => {
        //Call getFresh only if language has actually changed since last fetch
        if (scope.lastLangCode && scope.lastLangCode !== UserService.langCode) {
            ionicConfig.backButton.text(_locale('back').ucfirst());
            scope.getFresh(false);
        }
    }

    //Used to detect language change elsewhere.
    scope.$on('language.changed', scope.verifyLanguage);
    scope.$on('$ionicView.beforeEnter', scope.verifyLanguage);

    scope.stripHtml = (source) => {
        const tmpElement = document.createElement("DIV");
        tmpElement.innerHTML = sce.trustAsHtml(source) ;
        return tmpElement.textContent || tmpElement.innerText || source;
    };

    scope.setActiveNews = (news) => {
        //common.shared.activeNews = { content: news.content, id: news.id, title: news.title };

        ionicHistory.clearCache().then(() => {
            state.go('app.news', { articleId: news.id });
        });
    };

    scope.getFresh = (pull) => {
        slidesSettings.page = 1;
        newsSettings.page = 1;

        scope.lastLangCode = UserService.langCode;

        const promises = [ArticleService.getNewsFeed(slidesSettings),ArticleService.getNewsFeed(newsSettings)];

        Promise.all(promises.map(p => p.catch(() => undefined))).then((response) => {
            if (response[0])
                scope.slides = response[0].data.items;

            if (response[1]) {
                scope.news = response[1].data.items;
                scope.moreDataCanBeLoaded = !!response[1].data.next_page;
            }

            scope.$evalAsync(() => {
                if (pull)
                    scope.$broadcast('scroll.refreshComplete');

                scope.loading = false;
            });
        });
    };

    scope.infiniteScroll = () => {
        scope.moreDataCanBeLoaded = false;
        newsSettings.page++;
        
        ArticleService.getNewsFeed(newsSettings).then((response) => {
            scope.news = scope.news.concat(response.data.items);
            scope.moreDataCanBeLoaded = !!response.data.next_page;

            scope.$broadcast('scroll.infiniteScrollComplete');
        });
    };

    scope.getFresh(false);
}

TodayCtrl.$inject = $inject

export default TodayCtrl